import type { AgentChatMessageApi } from '@/api/client';
import { isValidAgentModelSlot } from '@/components/Messenger/agent/assistantChatMessageMetadata';
import type { TrackerChatMessage } from '@/components/Messenger/types/chatMessageTypes';

export function mapAgentApiMessageToUiMessage(m: AgentChatMessageApi): TrackerChatMessage {
  const role = m.role as 'user' | 'assistant' | 'system';
  const createdAt = typeof m.created_at === 'string' ? m.created_at : undefined;
  let metadata: TrackerChatMessage['metadata'] | undefined;
  if (role === 'user') {
    if (m.send_failed || createdAt) {
      metadata = { sendFailed: Boolean(m.send_failed), messageCreatedAt: createdAt };
    }
  } else if (role === 'assistant') {
    const ms = m.model_slot;
    if (isValidAgentModelSlot(ms)) {
      metadata = { modelSlot: ms, messageCreatedAt: createdAt };
    } else if (createdAt) {
      metadata = { messageCreatedAt: createdAt };
    }
  } else if (createdAt) {
    metadata = { messageCreatedAt: createdAt };
  }
  return {
    id: m.ui_message_id,
    role,
    parts: (Array.isArray(m.parts) ? m.parts : []) as TrackerChatMessage['parts'],
    metadata,
  };
}

export function collectPersistedAssistantIds(messages: TrackerChatMessage[]): Record<string, true> {
  const out: Record<string, true> = {};
  for (const m of messages) {
    if (m.role === 'assistant' && m.id) out[m.id] = true;
  }
  return out;
}
